export const CARS_TO_BUY_ROOT = 'cars-to-buy'
export const CARS_TO_BUY_BLIND_ROOT = 'cars-to-buy-blind'

export const CARS_TO_BUY_CAR_DETAILS = 'car-details'

export const getCarsToBuyUrl = (partnerId, plate, isBlind = false) => {
  const plateValue = plate ? `/${CARS_TO_BUY_CAR_DETAILS}/${plate}` : ''
  const partnerValue = partnerId ? `/${partnerId}` : ''
  const root = isBlind ? CARS_TO_BUY_BLIND_ROOT : CARS_TO_BUY_ROOT

  return !partnerId ? `/${root}` : `/${root}${partnerValue}${plateValue}`
}
